import React, { useState } from 'react';
import { supabase } from '../supabaseClient';
import { useLanguage } from '../LanguageContext';
import translations from '../translations';

function Login({ onLogin }) {
  const { language } = useLanguage();
  const t = translations[language];
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    if (!email || !password) {
      setMessage(t.enterEmailPassword);
      return;
    }

    setLoading(true);

    const { data, error } = await supabase.auth.signInWithPassword({ email, password });

    if (error) {
      setMessage('Error: ' + error.message);
      setLoading(false);
      return;
    }

    onLogin(data.user);
    setLoading(false);
  };

  return (
    <div>
      <div className="header">
        <h2>{t.staffLoginTitle}</h2>
        <p>{t.staffLoginSub}</p>
      </div>

      <input className="input" placeholder={t.email} type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
      <input className="input" placeholder={t.password} type="password" value={password} onChange={(e) => setPassword(e.target.value)} />

      <button className="btn btn-primary" onClick={handleLogin} disabled={loading}>
        {loading ? t.loggingIn : t.login}
      </button>

      {message && <div className="error-message">{message}</div>}
    </div>
  );
}

export default Login;